// extracted by mini-css-extract-plugin
export default {"line-graph":"DuCiC2E82TphdxqZQChA"};